const ar = {
	translation: {
		COMMON: {
			EMAIL: 'البريد الإلكتروني',
			EMAIL_REQUIRED: 'البريد الإلكتروني مطلوب',
			PASSWORD: 'كلمة المرور',
			PASSWORD_REQUIRED: 'كلمة المرور مطلوبة',
			DELETE: 'حذف',
			CONFIRM: 'تأكيد',
			VIEW: 'عرض',
			CHANGE: 'تغيير',
			DISCARD: 'الغاء',
			BACK: 'عوده',
			UPLOAD: 'رفع ملف',
			ADD: 'إضافة',
			SUCCESS: 'تم بنجاح',
			ERROR: 'حدث خطأ',
			OPS: 'خطأ',
			ERROR_OCCURRED: 'وقع خطأ أثناء استرجاع البيانات',
			ACTIONS: 'الإجراءات',
			CREATE: 'إنشاء',
			UPDATE: 'تحديث',
			INVALID_PHONE: 'رقم هاتف غير صحيح',
			PHONE_NUMBER: 'رقم الهاتف',
			SAR: 'ر.س',
			EDIT: 'تعديل',
			SEARCH: 'بحث',
			ID: 'الرقم التعريفي',
			DOWNLOAD: 'تحميل',
			CANCEL: 'الغاء',
			N_A: 'لا يوجد',
			NO_DATA: 'لا توجد بيانات',
			STATUS: 'الحالة',
			ONLY_PNG_JPG: 'يدعم فقط ملفات بصيغة PNG و JPG.',
			ACTIVE: 'نشط',
			INACTIVE: 'غير نشط',
			VERIFY: 'تحقق',
			PHONE_INVALID: 'رقم الهاتف غير صحيح',
			PHONE_REQUIRED: 'رقم الهاتف مطلوب',
			PENDING: 'قيد الانتظار',
			APPROVED: 'موافق عليه',
			REJECTED: 'مرفوض',
			CANCELED: 'ملغى',
			RELEASED: 'فك ارتباط',
			BLOCKED: 'محظور',
			UNDERREVIEW: 'قيد المراجعة',
			PHONEVERIFIED: 'تم التحقق من الهاتف',
			REJECT_REASON: 'سبب الرفض',
			REJECT_REASON_REQUIRED: 'سبب الرفض مطلوب',
			FIELD_REQUIRED: 'هذا الحقل مطلوب',
			NUMBERS_ONLY: 'مسموح بارقام فقط',
			REJECT_REASON_LENGTH: 'يجب أن يكون سبب الرفض بين 4 و 200 حرف',
		},
		LOGIN: {
			TITLE: 'مرحبا بطلنا',
			SUBTITLE: 'مرحبا بكم في تناقل',
			REMEMBER_ME: 'تذكرني',
			LOGIN: 'تسجيل الدخول',
			OTP_VERIFICATION: 'تحقق OTP',
			ENTER_OTP: 'أدخل OTP المرسل إلى رقم هاتفك',
			INVALID_OTP: 'OTP غير صالح',
		},
		SIDEBAR: {
			SPLASH_SCREENS: 'شاشات البداية',
			ROLES: 'الأدوار',
			ADMINS: 'المسؤولون',
			CLIENTS: 'المستخدمون',
			COUNTRIES: 'الدول',
			REGIONS: 'المناطق',
			CITIES: 'المدن',
			DISTRICTS: 'الأحياء',
			CURRENCIES: 'العملات',
			LANGUAGES: 'اللغات',
			BANKS: 'البنوك',
			SETTINGS: 'الإعدادات',
			DASHBOARD: 'لوحة التحكم',
			ORDERS: 'الطلبات',
			ADMIN_MANAGE: 'إدارة المسؤولين',
			GEOGRAPHIC: 'إعدادات الجغرافيا',
			FINANCE: 'الماليات',
			SUBSCRIPTIONS: 'الإشتراكات',
			MINORS: 'قاصرين ',
			INCOMPETENTS: 'فاقدي الأهلية',
			COMMERCIAL_ENTITIES: 'الكيانات التجارية',
		},
		SPLASH_SCREENS: {
			TITLE: 'إعدادات شاشة البداية',
			REARRANGE: 'إعادة الترتيب',
			ADD_SCREEN: 'إضافة شاشة',
			DELETE: 'حذف شاشة البداية',
			DELETE_MODAL_DESCRIPTION: 'سيتم حذف شاشة البداية نهائيًا من لوحة تحكم تناقل الخاصة بك',
			DELETE_MODAL_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذه الشاشة سيتم حذفها نهائيًا من لوحة التحكم الخاصة بنا',
			ADD_SPLASH_SCREEN: 'اضافة شاشة بدأ جديدة',
			INFORMATION: 'معلومات',
			ARABIC_TITLE: 'العنوان باللغة العربية',
			ARABIC_TITLE_REQUIRED: 'العنوان باللغة العربية مطلوب',
			ENGLISH_TITLE: 'العنوان باللغة الإنجليزية',
			ENGLISH_TITLE_REQUIRED: 'العنوان باللغة الإنجليزية مطلوب',
			ENGLISH_DESCRIPTION: 'الوصف باللغة الإنجليزية',
			ENGLISH_DESCRIPTION_REQUIRED: 'الوصف باللغة الإنجليزية مطلوب',
			ARABIC_DESCRIPTION: 'الوصف باللغة العربية',
			ARABIC_DESCRIPTION_REQUIRED: 'الوصف باللغة العربية مطلوب',
			MEDIA: 'الوسائط',
			BACKGROUND_COLOR: 'لون الخلفية',
			DELETED: 'تم حذف شاشة البداية',
			DELETE_ERROR: 'حدث خطأ أثناء حذف شاشة البداية',
			SORTED: 'تم ترتيب شاشات البداية',
			SORT_ERROR: 'حدث خطأ أثناء ترتيب شاشات البداية',
		},
		ROLES: {
			TITLE: 'إعدادات الأدوار',
			ROLES: 'أدوار',
			MANAGE_ROLES: 'إدارة الأدوار الخاصة بك',
			ROLE_NAME: 'اسم الدور',
			DELETE_ROLE: 'حذف الدور',
			DELETE_MODAL_DESCRIPTION: 'سيتم حذف الدور نهائيًا من لوحة تحكم تناقل الخاصة بك',
			DELETE_MODAL_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذا الدور سيتم حذفها نهائيًا من لوحة التحكم الخاصة بنا',
			DELETED: 'تم حذف الدور',
			DELETE_ERROR: 'حدث خطأ أثناء حذف الدور',
			ADD_NEW: 'إضافة دور جديد',
			ADMIN_ROLE_INF: 'معلومات دور المسؤول',
			ROLE_NAME_REQUIRED: 'اسم الدور مطلوب',
			ADMIN_ROLE: 'دور المسؤول',
			MODULE: 'القسم',
			PROFILE: 'بروفايل',
			ROLE: 'الأدوار',
			ADMIN: 'المسؤولين',
			PERMISSION: 'الإذونات',
			LANGUAGE: 'اللغات',
			CURRENCY: 'العمللات',
			COUNTRY: 'الدول',
			REGION: 'المناطق',
			CITY: 'المدن',
			DISTRICT: 'الأحياء',
			WALLET: 'المحفظة',
			MOBILE: 'شاشات البداية',
			BANK: 'البنك',
			SETTING: 'الإعدادات',
			SETTING_CATEGORY: 'فئة الإعدادات',
			USER: 'المستخدمين',
			BALANCE: 'الرصيد',
			PAYMENT: 'المدفوعات',
			ROLE_CREATED: 'تم انشاء الدور',
			ROLE_ALREADY_EXIST: 'اسم الدور موجود بالفعل',
			ROLE_CREATE_ERROR: 'خطأ عند إنشاء الدور',
			UPDATE_ROLE: 'تحديث الدور',
			ROLE_UPDATED: 'تم تحديث الدور',
			ROLE_UPDATE_FAILED: 'خطأ اثناء تحديث الدور',
			MINOR: 'القاصرين',
			INVESTMENT: 'الكيانات الاستثمار',
			INCOMPETENT: 'فاقدي الاهلية',
		},
		USERS: {
			TITLE: 'بوابة العملاء',
			CLIENT: 'العميل',
			CLIENTS: 'العملاء',
			MANAGE_CLIENTS: 'إدارة عملاء النظام',
			CLIENT_ID: 'معرف العميل',
			NATIONAL_ID: 'الرقم الوطني',
			REGISTRY_DATE: 'تاريخ التسجيل',
			STATUS: 'الحالة',
			ADD_CLIENT: 'إضافة عميل جديد',
			CLIENT_DETAILS: 'تفاصيل العميل',
			NAME_ARABIC: 'الاسم باللغة العربية',
			ENTER_NAME_ARABIC: 'أدخل الاسم باللغة العربية',
			NAME_ENGLISH: 'الاسم باللغة الإنجليزية',
			ENTER_NAME_ENGLISH: 'أدخل الاسم باللغة الإنجليزية',
			ENTER_NATIONAL_ID: 'أدخل رقم الهوية الوطنية',
			DATE_OF_BIRTH: 'تاريخ الميلاد',
			ENTER_DATE_BIRTH: 'أدخل تاريخ الميلاد',
			ADDRESS: 'العنوان',
			ENTER_ADDRESS: 'أدخل العنوان',
			PASSWORD: 'كلمة المرور',
			ENTER_PASSWORD: 'أدخل كلمة المرور',
			CONFIRM_PASSWORD: 'تأكيد كلمة المرور',
			ENTER_CONFIRM_PASSWORD: 'أدخل تأكيد كلمة المرور',
			LOCALE: 'اللغة',
			COUNTRY: 'البلد',
			AR_NAME_REQUIRED: 'الرجاء إدخال الاسم العربي للعميل!',
			EN_NAME_REQUIRED: 'الرجاء إدخال الاسم الإنجليزي للعميل!',
			NATIONAL_ID_REQUIRED: 'الرجاء إدخال رقم الهوية الوطنية للعميل!',
			DATE_BIRTH_REQUIRED: 'الرجاء إدخال تاريخ ميلاد العميل!',
			CLIENT_ADDRESS_REQUIRED: 'الرجاء إدخال عنوان العميل!',
			CLIENT_PASSWORD_REQUIRED: 'الرجاء إدخال كلمة مرور العميل!',
			CONFIRM_PASSWORD_REQUIRED: 'الرجاء إدخال تأكيد كلمة المرور!',
			LOCAL_REQUIRED: 'الرجاء تحديد لغة العميل!',
			COUNTRY_REQUIRED: 'الرجاء تحديد بلد العميل!',
			CLIENT_DELETED: 'تم حذف العميل بنجاح',
			CLIENT_NOT_DELETED: 'خطأ في حذف العميل المحدد',
			DELETE_CLIENT: 'حذف العميل',
			DELETE_MODAL_DESCRIPTION: 'سيتم إزالة العميل بشكل كامل من لوحة معلومات تناقل الخاصة بك',
			DELETE_MODAL_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذا سيتم إزالة العميل بشكل كامل من لوحة التحكم الخاصة بنا',
			CLIENT_CREATED: 'تم إنشاء العميل بنجاح',
			CLIENT_NOT_CREATED: 'حدث خطأ عند إنشاء العميل',
			MIN_12: 'الحد الأدنى للرقم هو 12 حرفًا',
			MAX_60: 'الحد الأقصى للرقم هو 60 حرفًا',
			NATIONAL_ID_10: 'يجب أن يكون الرقم الوطني 10 أرقام',
			PASSWORD_8_CHARS: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
			FETCH_CLIENT_ERROR: 'خطأ عند جلب بيانات العميل',
			CLIENT_UPDATED: 'تم تحديث العميل بنجاح',
			CLIENT_NOT_UPDATED: 'حدث خطأ عند تحديث العميل',
			UPDATE_CLIENT: 'تحديث العميل',
			BLOCK_REASON: 'سبب الحظر',
			BLOCK_REASON_REQUIRED: 'سبب الحظر مطلوب',
			ENTER_REASON: 'أدخل السبب',
			CHANGE_CLIENT_PASSWORD: 'تغيير كلمة مرور العميل',
			CHANGE_PASSWORD: 'تغيير كلمة المرور',
			PASSWORDS_NOT_MATCH: 'كلمة المرور وتأكيد كلمة المرور لا يتطابقان',
			CLIENT_PASSWORD_UPDATED: 'تم تحديث كلمة مرور العميل بنجاح',
			CLIENT_PASSWORD_NOT_UPDATED: 'حدث خطأ عند تحديث كلمة مرور العميل',
			SHARE_TRANSACTIONS: 'معاملات المشاركة',
			INVESTMENTS: 'الاستثمارات',
			COMPANIES: 'الشركات',
			WALLET_TRANSACTIONS: 'معاملات المحفظة',
			BANK_ACCOUNTS: 'الحسابات المصرفية',
			PAYMENTS: 'المدفوعات',
			WITHDRAW_REQUESTS: 'طلبات السحب',
			POINT_WALLET_TRANSACTIONS: 'معاملات محفظة النقاط',
			AVAILABLE_BUYING_POWER: 'القدرة الشرائية المتاحة',
			AVAILABLE_WITHDRAW: 'متاح للسحب',
			TYPE: 'النوع',
			COMPANY_NAME: 'اسم الشركة',
			COMPANY_CODE: 'كود الشركة',
			ROLE: 'الدور',
			STATUS_KEY: 'مفتاح الحالة',
			DATE: 'التاريخ',
			QUANTITY: 'الكمية',
			PRICE_SHARE: 'السعر/السهم',
			ALL: 'الكل',
			PENDING: 'قيد الانتظار',
			REJECTED: 'المرفوضة',
			CANCELED: 'الملغاه',
			EXPIRED: 'المنتهية',
			COMPLETED: 'المكتملة',
			COMPANY_COUNTRY: 'بلد الشركة',
			COMPANY_SECTOR: 'قطاع الشركة',
			TRANSACTION_ROLE: 'دور المعاملة',
			SELLER_NATIONAL_ID: 'معرف البائع الوطني',
			ORDER_TYPE: 'نوع الطلب',
			ALL_OR_NONE: 'الكل أو لا شيء',
			DATE_AND_TIME: 'التاريخ والوقت',
			EXPIRY: 'انتهاء الصلاحية',
			PRICE_PER_SHARE: 'السعر لكل سهم',
			TOTAL_SUM: 'المبلغ الإجمالي',
			COMMISSION: 'العمولة',
			VAT_PERCENTAGE: 'نسبة ضريبة القيمة المضافة',
			VAT: 'ضريبة القيمة المضافة',
			ESTIMATED_ORDER_VALUE: 'قيمة الطلب المقدرة',
			SELLER_ACCEPTED: 'قبول البائع',
			BUYER_ACCEPTED: 'قبول المشترى',
			ACCEPTED: 'وافق',
			DECLINED: 'لم يوافق',
			COMPANY_LOGO: 'لوجو الشركة',
			AVERAGE_BUYING_PRICE: 'متوسط ​​سعر الشراء',
			FOUNDER: 'المؤسس',
			EXECUTIVE: 'التنفيذي',
			BOARD_OF_DIRECTORS: 'مجلس الإدارة',
			DETAILS: 'التفاصيل',
			OVERVIEW: 'نظرة عامة',
			DOCUMENTS: 'الملفات',
			COMMON_SHARE_COUNT: 'عدد الأسهم العادية',
			EQUITY_PERCENTAGE: 'نسبة الأسهم',
			FREE_COMMON_SHARE_COUNT: 'عدد الأسهم العادية المجانية',
			FREE_PREFERRED_SHARE_COUNT: 'عدد الأسهم الممتازة المجانية',
			FILLY_PAID: 'مدفوع بالكامل',
			MORTGAGE_COMMON_SHARES_COUNT: 'عدد الأسهم العادية المرهونة',
			MORTGAGE_PREFERRED_SHARES_COUNT: 'عدد الأسهم الممتازة المرهونة',
			OFFERED_COMMON_SHARES_COUNT: 'عدد الأسهم العادية المعروضة',
			PREFERRED_SHARES_COUNT: 'عدد الأسهم الممتازة',
			PURCHASE_COST: 'تكلفة الشراء',
			SUSPEND_COMMON_SHARES_COUNT: 'عدد الأسهم العادية المعلقة',
			SUSPEND_PREFERRED_SHARES_COUNT: 'عدد الأسهم المفضلة المعلقة',
			COMPANY_DOCUMENTS: 'ملفات {{name}}',
			AVERAGE_SHARE_PRICE: 'متوسط ​​سعر السهم',
			DAILY_VOLUME: 'الحجم اليومي',
			DAILY_VALUE: 'القيمة اليومية',
			COMPANY_MANAGER_NAME: 'اسم مدير الشركة',
			DESCRIPTION: 'الوصف',
			SIZE: 'الحجم',
			MB: 'ميجا بايت',
			KB: 'كيلو بايت',
			AMOUNT: 'المبلغ',
			NAME: 'الاسم',
			BANK: 'البنك',
			LOGO: 'لوجو',
			GATEWAY: 'المصدر',
			REFERENCE: 'المرجع',
			INVOICE_NO: 'رقم الفاتورة',
			EXPIRE: 'تاريخ الانتهاء',
			BILLER_CODE: 'كود صاحب الفاتورة',
			BILLER_NAME: 'اسم صاححب الفاتورة',
			UPDATE_TIME: 'تاريخ التحديث',
			REJECTION_REASON: 'سبب الرفض',
			REJECTION_REASON_REQUIRED: 'سبب الرفض مطلوب',
			ACCOUNT_NAME: 'اسم الحساب',
			COMPLETE_THE_REQUEST: 'إكمال الطلب',
			ARE_YOU_SURE_TO_COMPLETE: 'هل أنت متأكد من إكمال طلب السحب هذا؟',
			DELETE_THE_REQUEST: 'حذف الطلب',
			ARE_YOU_SURE_TO_DELETE: 'هل أنت متأكد من حذف طلب السحب هذا؟',
			WITHDRAW_COMPLETED: 'تم إكمال طلب السحب بالمعرف ( {{requestId}} ',
			WITHDRAW_NOT_COMPLETED: 'حدث خطأ عند إكمال طلب السحب بالمعرف ( {{requestId}} ',
			WITHDRAW_DELETED: 'تم حذف طلب السحب بالمعرف ( {{requestId}} )',
			WITHDRAW_NOT_DELETED: 'حدث خطأ عند حذف طلب السحب بالمعرف ( {{requestId}} )',
			WITHDRAW_REJECTED: 'تم رفض طلب السحب بالمعرف ( {{requestId}} )',
			WITHDRAW_NOT_REJECTED: 'حدث خطأ عند رفض طلب السحب بالمعرف ( {{requestId}} )',
			DELETE_WITHDRAW_REQUEST: 'حذف طلب السحب بالمعرف ( {{requestId}} )',
			BASE_AMOUNT: 'المبلغ الأساسي',
			VAT_AMOUNT: 'مبلغ ضريبة القيمة المضافة',
			LAST_UPDATE: 'اخر تحديث',
			CURRENCY: 'العملة',
			EMAIL: 'البريد الاكترزني',
			EMAIL_REQUIRED: 'البريد الاكتروني مطلوب',
			EMAIL_NOT_VALID: 'البريد الاكتروني غير صحيح',
			ENTER_EMAIL: 'ادخل البريد الاكتروني',
			READ_LAST_AGREEMENT: 'اطلع على الاتفاقية الأخيرة',
			SEARCH: 'البحث بالاسم او الرقم الوطني او رقم الجوال',
			SIGNATURE: 'التوقيع',
			CHARGE: 'شحن',
			CHARGE_POINTS: 'شحن نقاط',
			CHARGE_POINTS_FOR_USER: 'شحن نقاط للعميل',
			SELECT_CHARGE_POINTS_AMOUNT: 'اختر مبلغ شحن النقاط',
			USER_WALLET_SUCCESS: 'تم شحن محفظة المستخدم بنجاح',
			ERROR_OCCURRED_CHARGE: 'حدث خطأ عند شحن محفظة المستخدم',
		},
		ADMINS: {
			PASSWORD_UPDATED: 'تم تغيير كلمة مرور المسؤول',
			PASSWORD_NOT_UPDATED: 'حدث خطأ عند تغيير كلمة مرور المسؤول',
			PASSWORD_8_CHARS: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
			PASSWORD_REQUIRED: 'الرجاء إدخال كلمة مرور المسؤول!',
			CONFIRM_PASSWORD_REQUIRED: 'الرجاء إدخال كلمة مرور التأكيد!',
			AUTHOR: 'المؤلف',
			ROLES: 'الدور',
			ADMIN_DELETED: 'تم حذف المسئول',
			ADMIN_NOT_DELETED: 'حدث خطأ اثناء حذف المسئول',
			ADMINS_MANAGEMENT: 'إدارة المسؤولين',
			ADMINS: 'المسؤولون',
			INVITE_ADMINS_AND_MANAGE_ACCESS: 'دعوة المسؤولين وإدارة وصولهم إلى حسابك',
			INVITE_ADMINS: 'دعوة المسؤولين',
			DELETE_ADMIN: 'حذف المسؤول',
			DELETE_MODAL_DESCRIPTION: 'سيتم إزالة المسؤول بشكل كامل من لوحة معلومات Tanaqul الخاصة بك',
			DELETE_MODAL_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذا المسؤول سيتم إزالتها بشكل كامل من لوحة المعلومات الخاصة بنا.',
			ADD_NEW_ADMIN: 'إضافة مسؤول جديد',
			INFORMATION: 'معلومات',
			FULL_NAME: 'الاسم بالكامل',
			FULL_NAME_REQUIRED: 'الاسم بالكامل مطلوب',
			EMAIL: 'البريد الإلكتروني',
			EMAIL_REQUIRED: 'البريد الإلكتروني مطلوب',
			EMAIL_NOT_VALID: 'البريد الإلكتروني غير صحيح',
			PASSWORD: 'كلمة المرور',
			AVATAR: 'الصورة الرمزية',
			UPLOAD: 'تحميل',
			ADMIN_ROLES: 'أدوار المسؤول',
			SEND_STAFF_INVITATION: 'إرسال دعوة للموظفين',
			ADMIN_STATUS_CHANGED: 'تم تغيير حالة المسؤول بنجاح',
			ADMIN_STATUS_NOT_CHANGED: 'حدث خطأ أثناء تحديث حالة المسؤول',
			ADMIN_UPDATED: 'تم تحديث بيانات المسؤول بنجاح',
			ADMIN_NOT_UPDATED: 'حدث خطأ أثناء تحديث بيانات المسؤول',
			EDIT_ADMIN: 'تعديل بيانات المسؤول',
			ACTIVATE: 'تفعيل',
			DEACTIVATE: 'إلغاء التفعيل',
			ADMIN_DETAILS: 'تفاصيل المسؤول',
		},
		COUNTRIES: {
			NAME: 'اسم الدولة',
			COUNTRIES: 'دولة',
			DELETE_TITLE: 'حذف الدولة',
			DELETE_DESCRIPTION: 'سيتم إزالة الدولة بشكل كامل من لوحة تحكم تناقل.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذه الدولة ستتم إزالتها بشكل كامل من لوحة التحكم لدينا.',
			MANAGEMENT: 'إدارة الدول',
			DELETE_ERROR: 'حدث خطأ أثناء حذف الدولة',
			DELETED_SUCCESS: 'تم حذف الدولة بنجاح',
			MANAGE_DESCRIPTION: 'قم بإدارة الدول في نظامك',
			CREATE_TITLE: 'إضافة دولة جديدة',
			DETAILS: 'تفاصيل الدولة',
			INFORMATION: 'معلومات',
			FLAG: 'علم الدولة',
			PLACEHOLDER: {
				NAME_EN: 'الاسم بالإنجليزية',
				NAME_AR: 'الاسم بالعربية',
				CODE: 'كود الدولة',
			},
			VALIDATION: {
				NAME_EN: 'يرجى إدخال الاسم بالإنجليزية!',
				NAME_AR: 'يرجى إدخال الاسم بالعربية!',
				CODE: 'يرجى إدخال كود الدولة!',
			},
			CREATED_SUCCESS: 'تمت إضافة الدولة بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إضافة الدولة',
			UPDATE_TITLE: 'تحديث الدولة',
			UPDATED_SUCCESS: 'تم تحديث الدولة بنجاح',
			UPDATE_BUTTON: 'تحديث',
			FETCH_ERROR: 'خطأ في جلب بيانات الدولة',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث الدولة',
		},
		REGIONS: {
			CREATE_TITLE: 'إضافة منطقة جديدة',
			DETAILS: 'تفاصيل المنطقة',
			INFORMATION: 'معلومات',
			COUNTRY: 'الدولة',
			PLACEHOLDER: {
				NAME_EN: 'الاسم باللغة الإنجليزية',
				NAME_AR: 'الاسم باللغة العربية',
			},
			VALIDATION: {
				NAME_EN: 'يرجى إدخال اسم المنطقة باللغة الإنجليزية!',
				NAME_AR: 'يرجى إدخال اسم المنطقة باللغة العربية!',
				COUNTRY: 'يرجى اختيار الدولة!',
			},
			CREATED_SUCCESS: 'تمت إضافة المنطقة بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إضافة المنطقة',
			MANAGEMENT_TITLE: 'إدارة المناطق',
			MANAGEMENT_COUNT: 'منطقة',
			MANAGEMENT_DESCRIPTION: 'قم بإدارة المناطق في نظامك',
			NAME: 'اسم المنطقة',
			DELETE_TITLE: 'حذف المنطقة',
			DELETE_DESCRIPTION: 'سيتم إزالة المنطقة بشكل كامل من النظام.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذه المنطقة سيتم حذفها نهائيًا.',
			DELETED_SUCCESS: 'تم حذف المنطقة بنجاح',
			DELETE_ERROR: 'حدث خطأ أثناء حذف المنطقة',
			UPDATE_TITLE: 'تحديث المنطقة',
			UPDATED_SUCCESS: 'تم تحديث المنطقة بنجاح',
			FETCH_ERROR: 'خطأ في جلب بيانات المنطقة',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث المنطقة',
		},
		CITIES: {
			CREATE_TITLE: 'إضافة مدينة جديدة',
			DETAILS: 'تفاصيل المدينة',
			INFORMATION: 'معلومات',
			REGION: 'المنطقة',
			PLACEHOLDER: {
				NAME_EN: 'الاسم باللغة الإنجليزية',
				NAME_AR: 'الاسم باللغة العربية',
			},
			VALIDATION: {
				NAME_EN: 'يرجى إدخال اسم المدينة باللغة الإنجليزية!',
				NAME_AR: 'يرجى إدخال اسم المدينة باللغة العربية!',
				REGION: 'يرجى اختيار المنطقة!',
			},
			CREATED_SUCCESS: 'تمت إضافة المدينة بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إضافة المدينة',
			MANAGEMENT_TITLE: 'إدارة المدن',
			MANAGEMENT_COUNT: 'مدينة',
			MANAGEMENT_DESCRIPTION: 'قم بإدارة المدن في نظامك',
			NAME: 'اسم المدينة',
			DELETE_TITLE: 'حذف المدينة',
			DELETE_DESCRIPTION: 'سيتم إزالة المدينة بشكل دائم من النظام.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذه المدينة سيتم حذفها نهائيًا.',
			DELETED_SUCCESS: 'تم حذف المدينة بنجاح',
			DELETE_ERROR: 'حدث خطأ أثناء حذف المدينة',
			UPDATE_TITLE: 'تحديث المدينة',
			UPDATED_SUCCESS: 'تم تحديث المدينة بنجاح',
			FETCH_ERROR: 'خطأ في جلب بيانات المدينة',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث المدينة',
		},
		DISTRICTS: {
			MANAGEMENT_TITLE: 'إدارة الأحياء',
			MANAGEMENT_COUNT: 'أحياء',
			MANAGEMENT_DESCRIPTION: 'قم بإدارة الأحياء في نظامك',
			NAME: 'اسم الحي',
			DELETED_SUCCESS: 'تم حذف الحي بنجاح',
			DELETE_TITLE: 'حذف الحي',
			DELETE_DESCRIPTION: 'سيتم حذف الحي بشكل دائم من النظام.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذا الحي سيتم حذفها نهائيًا.',
			DELETE_ERROR: 'حدث خطأ أثناء حذف الحي',
			CREATE_TITLE: 'إضافة حي جديد',
			DETAILS: 'تفاصيل الحي',
			INFORMATION: 'معلومات',
			CITY: 'المدينة',
			PLACEHOLDER: {
				NAME_EN: 'الاسم بالإنجليزية',
				NAME_AR: 'الاسم بالعربية',
			},
			VALIDATION: {
				NAME_EN: 'يرجى إدخال اسم الحي بالإنجليزية!',
				NAME_AR: 'يرجى إدخال اسم الحي بالعربية!',
				CITY: 'يرجى اختيار المدينة!',
			},
			CREATED_SUCCESS: 'تم إنشاء الحي بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إنشاء الحي',
			UPDATE_TITLE: 'تحديث الحي',
			UPDATED_SUCCESS: 'تم تحديث الحي بنجاح',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث الحي',
			FETCH_ERROR: 'خطأ في جلب بيانات الحي',
		},
		SUBSCRIPTIONS: {
			TITLE: 'الاشتراكات',
			COUNT: 'الاشتراكات',
			MANAGE_SUBSCRIPTIONS: 'قم بإدارة اشتراكات النظام',
			USER: 'المستخدم',
			TYPE: 'النوع',
			POINTS: 'النقاط',
			BASE_AMOUNT: 'المبلغ الأساسي',
			VAT_AMOUNT: 'مبلغ ضريبة القيمة المضافة',
			TOTAL_AMOUNT: 'المبلغ الإجمالي',
			BALANCE: 'الرصيد',
			VAT: 'الضريبة',
			TOTAL: 'الإجمالي',
			CURRENCY: 'العملة',
			DATE: 'التاريخ',
			DESCRIPTION: 'الوصف',
		},
		CURRENCIES: {
			CREATE_TITLE: 'إضافة عملة جديدة',
			DETAILS: 'تفاصيل العملة',
			SET_AS_DEFAULT: 'تعيين كافتراضي',
			PLACEHOLDER: {
				NAME_EN: 'الاسم بالإنجليزية',
				NAME_AR: 'الاسم بالعربية',
				CODE: 'الكود',
			},
			VALIDATION: {
				NAME_EN: 'يرجى إدخال اسم العملة بالإنجليزية!',
				NAME_AR: 'يرجى إدخال اسم العملة بالعربية!',
				CODE: 'يرجى إدخال الكود الخاص بالعملة!',
				CODE_LENGTH: 'يجب أن يكون طول الكود 3 أحرف',
			},
			CREATED_SUCCESS: 'تم إنشاء العملة بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إنشاء العملة',
			MANAGEMENT_TITLE: 'إدارة العملات',
			MANAGEMENT_COUNT: 'عملات',
			MANAGEMENT_DESCRIPTION: 'قم بإدارة العملات في نظامك',
			NAME: 'اسم العملة',
			CODE: 'الكود',
			DEFAULT: 'افتراضي',
			DELETED_SUCCESS: 'تم حذف العملة بنجاح',
			DELETE_TITLE: 'حذف العملة',
			DELETE_DESCRIPTION: 'سيتم إزالة العملة بشكل دائم من النظام.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذه العملة سيتم حذفها نهائيًا.',
			DELETE_ERROR: 'حدث خطأ أثناء حذف العملة',
			UPDATE_TITLE: 'تحديث العملة',
			UPDATED_SUCCESS: 'تم تحديث العملة بنجاح',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث العملة',
			FETCH_ERROR: 'خطأ في جلب بيانات العملة',
		},
		BANKS: {
			MANAGEMENT_TITLE: 'إدارة البنوك',
			MANAGEMENT_COUNT: 'بنك',
			MANAGEMENT_DESCRIPTION: 'قم بإدارة البنوك في نظامك',
			NAME: 'اسم البنك',
			DELETED_SUCCESS: 'تم حذف البنك بنجاح',
			DELETE_TITLE: 'حذف البنك',
			DELETE_DESCRIPTION: 'سيتم إزالة البنك بشكل دائم من النظام.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذا البنك سيتم حذفها نهائيًا.',
			DELETE_ERROR: 'حدث خطأ أثناء حذف البنك',
			CREATE_TITLE: 'إضافة بنك جديد',
			DETAILS: 'تفاصيل البنك',
			INFORMATION: 'معلومات',
			LOGO: 'شعار البنك',
			PLACEHOLDER: {
				NAME_EN: 'الاسم بالإنجليزية',
				NAME_AR: 'الاسم بالعربية',
			},
			VALIDATION: {
				NAME_EN: 'يرجى إدخال اسم البنك بالإنجليزية!',
				NAME_AR: 'يرجى إدخال اسم البنك بالعربية!',
			},
			CREATED_SUCCESS: 'تم إنشاء البنك بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إنشاء البنك',
			UPDATE_TITLE: 'تحديث البنك',
			UPDATED_SUCCESS: 'تم تحديث البنك بنجاح',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث البنك',
			FETCH_ERROR: 'خطأ في جلب بيانات البنك',
		},
		LANGUAGES: {
			MANAGEMENT_TITLE: 'إدارة اللغات',
			MANAGEMENT_COUNT: 'اللغات',
			MANAGEMENT_DESCRIPTION: 'قم بإدارة اللغات في نظامك',
			NAME: 'اسم اللغة',
			DEFAULT: 'افتراضي',
			DELETED_SUCCESS: 'تم حذف اللغة بنجاح',
			DELETE_TITLE: 'حذف اللغة',
			DELETE_DESCRIPTION: 'سيتم إزالة اللغة بشكل دائم من النظام.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذه اللغة سيتم حذفها نهائيًا.',
			DELETE_ERROR: 'حدث خطأ أثناء حذف اللغة',
			CREATE_TITLE: 'إضافة لغة جديدة',
			DETAILS: 'تفاصيل اللغة',
			INFORMATION: 'معلومات',
			FLAG: 'علم اللغة',
			PLACEHOLDER: {
				NAME: 'اسم اللغة',
				CODE: 'كود اللغة',
			},
			VALIDATION: {
				NAME: 'يرجى إدخال اسم اللغة!',
				CODE: 'يرجى إدخال كود اللغة!',
			},
			CREATED_SUCCESS: 'تم إنشاء اللغة بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إنشاء اللغة',
			UPDATE_TITLE: 'تحديث اللغة',
			UPDATED_SUCCESS: 'تم تحديث اللغة بنجاح',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث اللغة',
			FETCH_ERROR: 'خطأ في جلب بيانات اللغة',
		},
		SETTINGS: {
			MANAGEMENT_TITLE: 'إدارة الإعدادات',
			SPLASH_SCREENS: 'شاشات البداية',
		},
		MINORS: {
			THE_MINORS: 'القاصرين',
			MINORS: 'قاصرين',
			MINOR: 'القاصر',
			MINOR_ID: 'معرف القاصر',
			GARDIAN: 'ولي الأمر',
			FAMILY_ID_DOCUMENT: 'هوية العائلة',
			CUSTODY_ORDER_DOCUMENT: 'صك الحضانة',
			DELETE_TITLE: 'حذف القاصر',
			DELETE_DESCRIPTION: 'سيتم إزالة القاصر بشكل دائم من لوحة تحكم Tanaqoul الخاصة بك.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بهذا القاصر سيتم حذفها نهائيًا من لوحة التحكم لدينا.',
			MANAGEMENT_DESCRIPTION: 'إدارة القاصرين في نظامك',
			DELETE_ERROR: 'خطأ في حذف القاصر المحدد',
			DELETED_SUCCESS: 'تم حذف القاصر بنجاح',
			MINOR_APPROVED: 'تمت الموافقة على القاصر بنجاح',
			MINOR_NOT_APPROVED: 'حدث خطأ أثناء الموافقة على القاصر',
			MINOR_REJECTED: 'تم رفض القاصر بنجاح',
			MINOR_NOT_REJECTED: 'حدث خطأ أثناء رفض القاصر',
			MINOR_UNLINKED: 'تم فصل القاصر بنجاح',
			MINOR_NOT_UNLINKED: 'حدث خطأ أثناء فصل القاصر',
			MANAGE_DESCRIPTION: 'إدارة القاصرين في نظامك',
			CREATE_TITLE: 'إضافة قاصر جديد',
			DETAILS: 'تفاصيل القاصر',
			CREATED_SUCCESS: 'تم إنشاء القاصر بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إضافة القاصر',
			UPDATE_TITLE: 'تحديث القاصر',
			UPDATED_SUCCESS: 'تم تحديث القاصر بنجاح',
			FETCH_ERROR: 'خطأ في جلب بيانات القاصر',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث القاصر',
			PENDING: 'قيد الانتظار',
			APPROVE: 'الموافقة',
			REJECT: 'رفض',
			UNLINK: 'فصل',
			UNLINK_TITLE: 'فصل القاصر',
			UNLINK_DESCRIPTION: 'هل أنت متأكد أنك تريد فصل هذا القاصر عن ولي أمره؟',
			APPROVE_TITLE: 'الموافقة على القاصر',
			APPROVE_DESCRIPTION: 'هل أنت متأكد أنك تريد الموافقة على هذا القاصر؟',
			REJECT_TITLE: 'رفض القاصر',
			REJECT_DESCRIPTION: 'هل أنت متأكد أنك تريد رفض هذا القاصر؟',
			MINOR_DETAILS: 'تفاصيل القاصر',
			GARDIAN_DETAILS: 'تفاصيل ولي الأمر',
			APPROVED: 'مربوط',
			REJECTED: 'مرفوض',
			CANCELED: 'ملغى',
			RELEASED: 'فك ارتباط',
			BLOCKED: 'محظور',
			UNDERREVIEW: 'قيد المراجعة',
		},
		INCOMPETENTS: {
			INCOMPETENTS: 'فاقدي الأهلية',
			INCOMPETENT: 'فاقد للأهلية',
			INCOMPETENT_ID: 'معرف فاقد الأهلية',
			GARDIAN: 'ولي الأمر',
			FAMILY_ID_DOCUMENT: 'هوية العائلة',
			CUSTODY_ORDER_DOCUMENT: 'صك الحضانة',
			GUARDIANSHIP_ORDER_DOCUMENT: 'صك الولاية',
			DELETE_TITLE: 'حذف فاقد الأهلية',
			DELETE_DESCRIPTION: 'سيتم إزالة فاقد الأهلية بشكل دائم من لوحة تحكم تناقل الخاصة بك.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بفاقد الأهلية سيتم حذفها نهائيًا من لوحة التحكم لدينا.',
			MANAGEMENT_DESCRIPTION: 'إدارة فاقدي الأهلية في نظامك',
			DELETE_ERROR: 'خطأ في حذف فاقد الأهلية المحدد',
			DELETED_SUCCESS: 'تم حذف فاقد الأهلية بنجاح',
			INCOMPETENT_APPROVED: 'تمت الموافقة على فاقد الأهلية بنجاح',
			INCOMPETENT_NOT_APPROVED: 'حدث خطأ أثناء الموافقة على فاقد الأهلية',
			INCOMPETENT_REJECTED: 'تم رفض فاقد الأهلية بنجاح',
			INCOMPETENT_NOT_REJECTED: 'حدث خطأ أثناء رفض فاقد الأهلية',
			INCOMPETENT_UNLINKED: 'تم فصل فاقد الأهلية بنجاح',
			INCOMPETENT_NOT_UNLINKED: 'حدث خطأ أثناء فصل فاقد الأهلية',
			MANAGE_DESCRIPTION: 'إدارة فاقدي الأهلية في نظامك',
			DETAILS: 'تفاصيل فاقد الأهلية',
			CREATED_SUCCESS: 'تم إنشاء فاقد الأهلية بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إضافة فاقد الأهلية',
			FETCH_ERROR: 'خطأ في جلب بيانات فاقد الأهلية',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث فاقد الأهلية',
			PENDING: 'قيد الانتظار',
			APPROVE: 'الموافقة',
			REJECT: 'رفض',
			UNLINK: 'فصل',
			UNLINK_TITLE: 'فصل فاقد الأهلية',
			UNLINK_DESCRIPTION: 'هل أنت متأكد أنك تريد فصل فاقد الأهلية عن ولي أمره؟',
			APPROVE_TITLE: 'الموافقة على فاقد الأهلية',
			APPROVE_DESCRIPTION: 'هل أنت متأكد أنك تريد الموافقة على فاقد الأهلية؟',
			REJECT_TITLE: 'رفض فاقد الأهلية',
			REJECT_DESCRIPTION: 'هل أنت متأكد أنك تريد رفض فاقد الأهلية؟',
			INCOMPETENT_DETAILS: 'تفاصيل فاقد الأهلية',
			GARDIAN_DETAILS: 'تفاصيل ولي الأمر',
		},
		COMMERCIAL_ENTITIES: {
			COMMERCIAL_ENTITIES: 'الكيانات التجارية',
			COMMERCIAL_ENTITY: 'كيان تجاري',
			COMMERCIAL_ENTITY_ID: 'معرف الكيان التجاري',
			GARDIAN: 'المفوض',
			FAMILY_ID_DOCUMENT: 'وثيقة هوية الأسرة',
			CUSTODY_ORDER_DOCUMENT: 'وثيقة أمر الحضانة',
			DELETE_TITLE: 'حذف الكيان التجاري',
			DELETE_DESCRIPTION: 'سيتم إزالة الكيان التجاري بشكل دائم من لوحة تحكم تناقل الخاصة بك.',
			DELETE_NOTE: 'يرجى ملاحظة أن جميع البيانات المتعلقة بالكيان التجاري سيتم حذفها نهائيًا من لوحة التحكم لدينا.',
			MANAGEMENT_DESCRIPTION: 'إدارة الكيانات التجارية في نظامك',
			DELETE_ERROR: 'خطأ في حذف الكيان التجاري المحدد',
			DELETED_SUCCESS: 'تم حذف الكيان التجاري بنجاح',
			COMMERCIAL_ENTITY_APPROVED: 'تمت الموافقة على الكيان التجاري بنجاح',
			COMMERCIAL_ENTITY_NOT_APPROVED: 'حدث خطأ أثناء الموافقة على الكيان التجاري',
			COMMERCIAL_ENTITY_REJECTED: 'تم رفض الكيان التجاري بنجاح',
			COMMERCIAL_ENTITY_NOT_REJECTED: 'حدث خطأ أثناء رفض الكيان التجاري',
			COMMERCIAL_ENTITY_UNLINKED: 'تم فصل الكيان التجاري بنجاح',
			COMMERCIAL_ENTITY_NOT_UNLINKED: 'حدث خطأ أثناء فصل الكيان التجاري',
			MANAGE_DESCRIPTION: 'إدارة الكيانات التجارية في نظامك',
			DETAILS: 'تفاصيل الكيان التجاري',
			CREATED_SUCCESS: 'تم إنشاء الكيان التجاري بنجاح',
			CREATE_ERROR: 'حدث خطأ أثناء إضافة الكيان التجاري',
			FETCH_ERROR: 'خطأ في جلب بيانات الكيان التجاري',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث الكيان التجاري',
			APPROVE: 'الموافقة',
			REJECT: 'رفض',
			UNLINK: 'فصل',
			UNLINK_TITLE: 'فصل الكيان التجاري',
			UNLINK_DESCRIPTION: 'هل أنت متأكد أنك تريد فصل الكيان التجاري عن ولي أمره؟',
			APPROVE_TITLE: 'الموافقة على الكيان التجاري',
			APPROVE_DESCRIPTION: 'هل أنت متأكد أنك تريد الموافقة على الكيان التجاري؟',
			REJECT_TITLE: 'رفض الكيان التجاري',
			REJECT_DESCRIPTION: 'هل أنت متأكد أنك تريد رفض الكيان التجاري؟',
			COMMERCIAL_ENTITY_DETAILS: 'تفاصيل الكيان التجاري',
			GARDIAN_DETAILS: 'تفاصيل المفوض',
			UNIFIED_CR: ' الرقم الموحد للسجل التجاري',
			UNIFIED_CR_10: ' الرقم الموحد للسجل التجاري يجب أن يكون 10 أرقام',
			CR_NUMBER: 'رقم السجل التجاري',
			CR_NUMBER_10: 'رقم السجل التجاري يجب أن يكون 10 أرقام',
			CR_DOCUMENT: 'السجل التجاري',
			APPROVED_AUTHORIZED_DOCUMENT: 'وثيقة التفويض المعتمد',
			PENDING: 'قيد الانتظار',
			APPROVED: 'منقول',
			REJECTED: 'مرفوض',
			CANCELED: 'ملغى',
			RELEASED: 'فك ارتباط',
			BLOCKED: 'محظور',
			UNDERREVIEW: 'قيد المراجعة',
			UPDATE_TITLE: 'تحديث الكيان التجاري',
			UPDATED_SUCCESS: 'تم تحديث الكيان التجاري بنجاح',
			NAME_AR: 'الاسم باللغة العربية',
			NAME_EN: 'الاسم باللغة الإنجليزية',
			NAME_AR_REQUIRED: 'الاسم باللغة العربية مطلوب',
			NAME_EN_REQUIRED: 'الاسم باللغة الإنجليزية مطلوب',
		},
	},
};

export default ar;
